export default {
    type: 'services',
    aliases: {
        camel: 'services',
        singular: 'Service',
        plural: 'Services',
        lowerSingular: 'service',
        lowerPlural: 'services',
    },
    relations: {
        'modules': {
            pivot: {
                type: 'service-modules',
                localKey: 'serviceId',
                foreignKey: 'moduleId'
            }
        },
        'service-categories': {
            adminLabel: "Categories",
            pivot: {
                type: 'service-service-categories',
                localKey: 'serviceId',
                foreignKey: 'serviceCategoryId'
            }
        },
    },
    publishable: true,
    adminSection: 'services',
    componentType: 'base',
    filterOn: {
        'other': ['isPublished'],
    },
    components: {
        adminCollection: {
            name: 'AdministerPublishableCollection',
            loader: () => import('@/services/publication/ui/AdministerPublishableCollection')
        },
        adminCollectionItem: {
            name: 'AdministerPublishableCollectionItem',
            loader: () => import('@/services/publication/ui/AdministerPublishableCollectionItem')
        },
        adminRecord: {
            name: 'AdministerServiceRecord',
            loader: () => import('./AdministerServiceRecord')
        },
        webRecord: {
            name: 'DisplayServiceRecord',
            loader: () => import('./DisplayServiceRecord')
        },
    },
};
